import { generateQueryKey } from '../../app/utils/react-query-utils';

enum QueryKeyIdentifier {
    // todo: (liquidity-activated) remove once feature is stable and officially released
    LIQUIDITY_OVERVIEW_ACTIVATED = 'LIQUIDITY_OVERVIEW_ACTIVATED',
    LIQUIDITY_OVERVIEW = 'LIQUIDITY_OVERVIEW',
    LIQUIDITY_CALCULATOR_CALCULATION = 'LIQUIDITY_CALCULATOR_CALCULATION',
    LIQUIDITY_RECURRING_CASHFLOW_SETTINGS = 'LIQUIDITY_RECURRING_CASHFLOW_SETTINGS',
    LIQUIDITY_ONE_OFF_CASHFLOW_SETTINGS = 'LIQUIDITY_ONE_OFF_CASHFLOW_SETTINGS',
    LIQUIDITY_CASH_WITH_JB_SETTINGS = 'LIQUIDITY_CASH_WITH_JB_SETTINGS',
    LIQUIDITY_CASH_WITH_OTHER_BANKS_SETTINGS = 'LIQUIDITY_CASH_WITH_OTHER_BANKS_SETTINGS',
}

export const queryKeys = {
    liquidityOverviewActivated: () => generateQueryKey(QueryKeyIdentifier.LIQUIDITY_OVERVIEW_ACTIVATED, 'ITEM'),
    liquidityOverview: (partnerUuid?: string) => generateQueryKey(QueryKeyIdentifier.LIQUIDITY_OVERVIEW, 'ITEM', partnerUuid),
    liquidityCalculatorCalculation: (partnerUuid?: string) => generateQueryKey(QueryKeyIdentifier.LIQUIDITY_CALCULATOR_CALCULATION, 'ITEM', partnerUuid),
    liquidityRecurringCashflowSettings: (partnerUuid?: string) =>
        generateQueryKey(QueryKeyIdentifier.LIQUIDITY_RECURRING_CASHFLOW_SETTINGS, 'ITEM', partnerUuid),
    liquidityOneOffCashflowSettings: (partnerUuid?: string) => generateQueryKey(QueryKeyIdentifier.LIQUIDITY_ONE_OFF_CASHFLOW_SETTINGS, 'ITEM', partnerUuid),
    liquidityCashWithJbSettings: (partnerUuid?: string) => generateQueryKey(QueryKeyIdentifier.LIQUIDITY_CASH_WITH_JB_SETTINGS, 'ITEM', partnerUuid),
    liquidityCashWithOtherBanksSettings: (partnerUuid?: string) =>
        generateQueryKey(QueryKeyIdentifier.LIQUIDITY_CASH_WITH_OTHER_BANKS_SETTINGS, 'ITEM', partnerUuid),
};
